// Board empty-state copy: manifest override, else metadata noun, else "records".
import { pluralize } from 'inflected';
import type { EntityBoardEmptyConfig } from '../context';

/** Resolved copy the board empty overlay / host renders. */
export type ResolvedBoardEmptyState = {
  title: string;
  description?: string;
  icon?: string;
};

/**
 * Board empty-state copy. Manifest `empty` wins; otherwise `No {plural displayName}`,
 * or `No matching {plural}` plus a filter hint when the board is narrowed.
 */
export function resolveBoardEmptyState(args: { empty?: EntityBoardEmptyConfig | null; displayName?: string | null; filtered?: boolean }): ResolvedBoardEmptyState {

  const noun = pluralize(args.displayName?.trim() || 'record');
  const filtered = args.filtered === true;
  const title = args.empty?.title?.trim() || (filtered ? `No matching ${noun}` : `No ${noun}`);
  const description = args.empty?.description?.trim() || (filtered && !args.empty?.title?.trim() ? 'Try adjusting your filters or search.' : undefined);
  const icon = args.empty?.icon?.trim() || undefined;
  return description ? { title, description, icon } : { title, icon };
}
